// @flow

import * as React from 'react';

import {
  SectionsEditor,
  NameEditor,
  DefaultTransferCheckbox,
  DefaultRegistrationCheckbox,
} from '@gandi/template2';

import type { CreateOrTransfer } from 'src/Cart/Setup/types';

export type Props = {
  isNew?: boolean,
  process: CreateOrTransfer,
};

const Editor = ({ isNew, process }: Props): React.Node => (
  <>
    {isNew && <NameEditor marginBottom="small" />}
    <SectionsEditor marginBottom="small" />
    {process === 'transfer' && <DefaultTransferCheckbox marginBottom="small" />}
    {process === 'create' && <DefaultRegistrationCheckbox />}
  </>
);

export default Editor;
